/**
 * True when the PWA is running as an installed app rather than a browser tab.
 *
 * Both checks are needed: iOS Safari's home-screen apps don't match the
 * `display-mode` media query and report `navigator.standalone` instead, and iOS
 * is this app's primary target.
 */
export function isStandalone(): boolean {
  return (
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}
